import Mustache from "mustache";
import moment from "moment";
import {striptags, truncate} from "./tools";
import HeadingNavBar from "./heading-nav-bar";

export default class EventsCalendar {
    constructor() {
        this.apiUrl = '/wp-json/wp/v2/';
        this.selectedView = 'month';
        this.haveEvents = false;
        this.selectedDate = {year: null, month: null, day: null};
        this.currentDate = {year: moment().year(), month: moment().month() + 1, day: moment().date()};
        this.categoriesFilters__synced = false;
        this.categoriesFilters = {};
        this.emptyNoticeText = 'No events in selected month';
    }

    init() {
        this.CalendarWrapper = document.getElementById('events-calendar-wrapper');
        this.CalendarWrapper.dataset.selectedView = this.selectedView;

        if (!this.CalendarWrapper) {
            return false;
        }

        if (document.querySelector('#heading-menu-wrapper[data-kind="calendar_category"]')) {
            const headingNavBar = new HeadingNavBar();
            headingNavBar.manageHeadingNavBar(this);
        }


        this.fetchData().then(response => {
            this.prepareEvents(response);
        }).catch(error => {
            console.warn('Events request error occur', error);
        })

        this.setNewDate(this.currentDate);

        const modalDiv = document.createElement('div');
        modalDiv.setAttribute('id', 'eventModalDetails');
        modalDiv.innerHTML = '<div class="content events-list-section"></div><span class="apla"></span>';
        document.body.appendChild(modalDiv);
        modalDiv.addEventListener('click', e => e.target.getAttribute('id') && e.target.getAttribute('id') === 'eventModalDetails' && e.target.classList.remove('show'));

        this.CalendarWrapper.innerHTML = this.screenRenderer();

        // this.CategoriesEl = this.CalendarWrapper.querySelector('.categories');
        this.FiltersEl = this.CalendarWrapper.querySelector('.selectors');
        this.ModifierEl = this.CalendarWrapper.querySelector('.modifier');
        this.CalendarScreenEl = this.CalendarWrapper.querySelector('.calendar');

        this.CalendarScreenEl.innerHTML = this.calendarCardRenderer();

        this.connectGlobalEvents();

    }

    acfDateToDateFormat(stringValue) {
        if (stringValue && stringValue.length === 8) {
            return stringValue.substring(0, 4) + '-' + stringValue.substring(4, 6) + '-' + stringValue.substring(6, 8);
        }

        return stringValue;
    }

    /***
     * Pobiera listę kategorii wydarzeń
     *
     * @param newCategories
     */
    updateFiltersCategories(newCategories = {}) {
        this.categoriesFilters = newCategories;
        this.categoriesFilters__synced = true;
    }

    /***
     * Zmienia status zaznaczenia wybranej kategorii wydazeń
     *
     * @param category
     * @returns {*}
     */
    toggleCategoriesFilter(category) {
        Object.entries(this.categoriesFilters).forEach((el) => {
            this.categoriesFilters[el[0]] = false
        });

        if (category === 'all') {
            this.emptyNoticeText = 'No events in selected month.';
        } else {
            this.categoriesFilters['all'] = false;
            this.emptyNoticeText = 'No events with selected category.';
        }
        this.categoriesFilters[category] = true; //this.categoriesFilters[category];

        this.renderEvents();

        return this.categoriesFilters[category];
    }

    /***
     * Przygotowuje listę pobranych wydarzeń do potrzebnego formatu
     *
     * @param data
     */
    prepareEvents(data) {
        this.eventsList = {};
        this.eventsRowList = data;

        if (!this.categoriesFilters__synced) {
            this.categoriesFilters['all'] = true;
        }


        Object.entries(data).map(evEl => {
            const eventObject = evEl[1];
            const year = parseInt(eventObject.acf.date_start.substring(6, 10));
            const month = parseInt(eventObject.acf.date_start.substring(3, 5));
            const day = parseInt(eventObject.acf.date_start.substring(0, 2));

            // eventObject.acf.date_start = eventObject.acf.date_start;
            // eventObject.acf.date_end = eventObject.acf.date_end;

            if (!this.eventsList['y' + year]) {
                this.eventsList['y' + year] = [];
            }
            if (!this.eventsList['y' + year]['m' + month]) {
                this.eventsList['y' + year]['m' + month] = [];
            }
            if (!this.eventsList['y' + year]['m' + month]['d' + year + '-' + month + '-' + day]) {
                this.eventsList['y' + year]['m' + month]['d' + year + '-' + month + '-' + day] = [];
            }

            this.eventsList['y' + year]['m' + month]['d' + year + '-' + month + '-' + day].push(eventObject);
            if (!this.categoriesFilters__synced && eventObject.categories_list.length) {

                eventObject.categories_list.forEach(cat => this.categoriesFilters[cat.slug] = false);
            }

        });

        if (this.eventsList) {
            this.haveEvents = true;
        }

        this.renderEvents();
    }

    /***
     * Renderuje wydarzenia dla akualnego miesiąca
     *
     * @returns {boolean}
     */
    renderEvents() {
        if (!this.haveEvents) {
            return false;
        }
        this.updateEmptyNotice();

        this.CalendarScreenEl.classList.add('empty-month');
        this.CalendarScreenEl.querySelectorAll('.post-wrapper').forEach(p => {
            p.innerHTML = '';
            p.style.paddingTop = '0px'
        });

        if ('month' === this.selectedView) {
            //sprawdzamy eventy które się kończą w ostatnich dniach poprzedniego miesiąca

            const prevMonthDate = this.getSelectedDate('noformat').subtract(1, 'month');
            const nextMonthDate = this.getSelectedDate('noformat').add(1, 'month');

            if (this.eventsList['y' + prevMonthDate.format('YYYY')] && this.eventsList['y' + prevMonthDate.format('YYYY')]['m' + prevMonthDate.format('MM')]) {
                // console.log('Pobieramy eventy z poprzedniego miesiąca', prevMonthDate.format('YYYY-MM'), 'ilosc:', Object.entries(this.eventsList['y' + prevMonthDate.format('YYYY')]['m' + prevMonthDate.format('MM')]).length);
                Object.entries(this.eventsList['y' + prevMonthDate.format('YYYY')]['m' + prevMonthDate.format('MM')]).forEach(ev => {
                    this.renderEventIntoDay(ev);
                });
            }
            if (this.eventsList['y' + this.selectedDate.year] && this.eventsList['y' + this.selectedDate.year]['m' + this.selectedDate.month]) {
                Object.entries(this.eventsList['y' + this.selectedDate.year]['m' + this.selectedDate.month]).forEach(ev => {
                    this.renderEventIntoDay(ev)
                });
            }

            if (this.eventsList['y' + nextMonthDate.format('YYYY')] && this.eventsList['y' + nextMonthDate.format('YYYY')]['m' + nextMonthDate.format('MM')]) {
                // console.log('Pobieramy eventy z poprzedniego miesiąca', prevMonthDate.format('YYYY-MM'), 'ilosc:', Object.entries(this.eventsList['y' + prevMonthDate.format('YYYY')]['m' + prevMonthDate.format('MM')]).length);
                Object.entries(this.eventsList['y' + nextMonthDate.format('YYYY')]['m' + nextMonthDate.format('MM')]).forEach(ev => {
                    this.renderEventIntoDay(ev);
                });
            }
        } else {
            if (this.eventsList['y' + this.selectedDate.year]) {
                console.log(Object.entries(this.eventsList['y' + this.selectedDate.year]));
                Object.entries(this.eventsList['y' + this.selectedDate.year]).forEach(ev => {
                    this.renderEventIntoMonth(ev, this.selectedDate.year)
                });
            }

        }

        if (this.CalendarScreenEl.querySelectorAll('.one-el:not(.next-month) .post-wrapper li').length && this.CalendarScreenEl.classList.contains('empty-month')) {
            this.CalendarScreenEl.classList.remove('empty-month');
        }

    }

    /**
     * Render events list in month card
     *
     * @param monthWithEventObject
     * @param year
     */
    renderEventIntoMonth(monthWithEventObject, year) {
        const monthDateString = monthWithEventObject[0].substring(1, monthWithEventObject[0].length);
        const events = monthWithEventObject[1];
        const elDay = this.CalendarScreenEl.querySelector('.one-el[data-d-year="' + parseInt(year) + '"][data-d-month="' + parseInt(monthDateString) + '"]');

        elDay.querySelector('.post-wrapper').innerHTML = '';
        const availableCats = {};
        Object.entries(events).map(x => {
            if (x[1].length) {
                x[1].map(y => {
                    if (y.calendar_category && y.calendar_category.length) {
                        if (false === this.categoriesFilters['all'] && this.categoriesFilters[y.categories_list[0].slug] !== true) {
                            return false;
                        }

                        if (y.categories_list[0] && !availableCats[y.categories_list[0].slug]) {
                            availableCats[y.categories_list[0].slug] = y.categories_list[0];
                        }
                    } else {

                        if (!availableCats.nocat && true === this.categoriesFilters['all']) {
                            availableCats.nocat = {name: 'No category', bgColor: '#ccc', textColor: '#000'};
                        }
                    }
                });
            }
        });

        if (Object.entries(availableCats).length) {
            Object.entries(availableCats).forEach(x => {
                const li = document.createElement('li');
                const termDetails = x[1];
                li.innerHTML = '&nbsp;';
                li.setAttribute('title', striptags(termDetails.name ?? ''));
                li.dataset.eid = x[0];
                li.classList.add(x[0]);
                li.style.backgroundColor = termDetails.bgColor ?? '#FFF';
                li.style.color = termDetails.textColor ?? '#000';
                elDay.querySelector('.post-wrapper').appendChild(li);
                elDay.addEventListener('click', e => {
                    this.setNewDate({year: year, month: parseInt(monthDateString)});
                    this.changeView('month');
                });

            });
        }
    }

    reformatDate(dateFromAcf) {

        if (dateFromAcf.length !== 10) {
            return null;
        }

        return dateFromAcf.substring(6, 10) + '-' + dateFromAcf.substring(3, 5) + '-' + dateFromAcf.substring(0, 2);
    }

    /***
     * Renderuje listę wydarzeń w dla wybranego dnia ...
     *
     * @param dayWithEventObject
     */
    renderEventIntoDay(dayWithEventObject) {
        try {
            const allEvents = [...dayWithEventObject[1]]; // Array
            const pastMonth = moment([this.selectedDate.year, this.selectedDate.month, 1], 'YYYY-MM-DD').subtract(1, 'month').format('MM');
            const firstDayInCurrentMonth = moment([this.selectedDate.year, this.selectedDate.month, 1], 'YYYY-MM-DD').day() > 0 ? moment([this.selectedDate.year, this.selectedDate.month, 1], 'YYYY-MM-DD').day() : 7;
            const firstVisibleDayInPastMonth = moment([this.selectedDate.year, this.selectedDate.month, 1], 'YYYY-MM-DD').subtract(firstDayInCurrentMonth - 1, 'day');

            allEvents.forEach(eventObject => {
                if (eventObject.categories_list && eventObject.categories_list.length > 0) {
                    const r = eventObject.categories_list.filter(xx => {
                        return this.categoriesFilters['all'] === true || this.categoriesFilters[xx.slug] === true
                    });

                    if (eventObject.categories_list.length > 0 && !r.length) {
                        return false;
                    }

                } else if (this.categoriesFilters['all'] !== true) {
                    return false;
                }

                eventObject.title = eventObject.title.rendered ?? eventObject.title;
                eventObject.dates = {
                    'start': this.reformatDate(eventObject.acf.date_start),
                    'end': this.reformatDate(eventObject.acf.date_end) ?? this.reformatDate(eventObject.acf.date_start)
                };

                if (moment(eventObject.dates.start).format('MM') === pastMonth && moment(eventObject.dates.end).isBefore(firstVisibleDayInPastMonth)) {
                    return false;
                }

                if (moment(eventObject.dates.start, 'YYYY-MM-DD').isBefore(firstVisibleDayInPastMonth)) {
                    eventObject.dates.start = firstVisibleDayInPastMonth.format('YYYY-MM-DD');
                }

                this.renderEventLiElement(eventObject);

            });

        } catch (error) {
            console.error('Error occur in renderEventIntoDay');
            console.error(error);
        }
    }

    renderEventLiElement(eventObject) {
        const elDay = this.CalendarScreenEl.querySelector('.one-el[data-d-year="' + parseInt(moment(eventObject.dates.start).format('YYYY')) + '"][data-d-month="' + parseInt(moment(eventObject.dates.start).format('MM')) + '"][data-d-day="' + parseInt(moment(eventObject.dates.start).format('DD')) + '"]');
        // console.log('elDay', elDay);
        if (!elDay) {
            return false;
        }
        const li = document.createElement('li');
        let d = 1;
        let dMin = 1;
        if (eventObject.dates.end) {
            d = moment(eventObject.dates.end).diff(moment(eventObject.dates.start), 'days') + 1;
            dMin = Math.min(d, 8 - parseInt(elDay.dataset.dayNo));
            li.classList.add('multidays');
            li.classList.add('order-' + dMin);

            if (moment(eventObject.dates.end, 'YYYY-MM-DD').month() + 1 === this.selectedDate.month) {
                li.classList.add('mob-prev-month');
            }

            let tempDate = eventObject.dates.start;
            const getElPT = (el) => {
                return parseInt(isNaN(parseInt(el.style.paddingTop)) ? 0 : el.style.paddingTop);
            }
            for (let i = 1; i < dMin; i++) {
                let tempDateMod = moment(tempDate).add(i, 'day');
                const postWrapper = this.CalendarScreenEl.querySelector('.one-el[data-d-year="' + parseInt(tempDateMod.format('YYYY')) + '"][data-d-month="' + parseInt(tempDateMod.format('MM')) + '"][data-d-day="' + parseInt(tempDateMod.format('DD')) + '"]').querySelector('.post-wrapper');
                postWrapper.style.paddingTop = (getElPT(postWrapper) + 24) + 'px';
            }

            li.dataset.daysa = '' + d;
            li.style.width = 'calc(100% * ' + dMin + ' - 10%)';

            if (moment(eventObject.dates.start).diff(moment(this.reformatDate(eventObject.acf.date_start))) != 0) {
                li.classList.add('not-begin');
            }

            if (d > dMin) {
                li.classList.add('not-end');

                let eventObjectNextWeek = Object.assign({}, eventObject);
                eventObjectNextWeek.dates.start = moment(eventObjectNextWeek.dates.start).add(dMin, 'days').format('YYYY-MM-DD');
                this.renderEventLiElement(eventObjectNextWeek);

            }

        }

        li.innerHTML = truncate(striptags(eventObject.title), 20 * dMin);
        li.setAttribute('title', striptags(eventObject.title));
        li.dataset.eid = eventObject.id;
        if (eventObject.calendar_category && eventObject.categories_list[0]) {
            li.dataset.ecat = eventObject.categories_list[0].slug;
        }

        eventObject.calendar_category && eventObject.categories_list[0] && li.classList.add(eventObject.categories_list[0].slug);
        li.addEventListener('click', e => this.showModal(e.target.dataset.eid));
        li.style.backgroundColor = eventObject.categories_list[0] && eventObject.categories_list[0].bgColor ? eventObject.categories_list[0].bgColor : '#FFF';
        li.style.color = eventObject.categories_list[0] && eventObject.categories_list[0].textColor ? eventObject.categories_list[0].textColor : '#000';
        elDay.querySelector('.post-wrapper').appendChild(li);
        elDay.classList.add('has-events');
    }

    changeView(el) {
        let newView = 'month';

        if ('string' === typeof el) {
            newView = el;
            this.CalendarWrapper.querySelectorAll('button.select-view').forEach(b => b.classList.contains('selected') && b.classList.remove('selected'));
            this.CalendarWrapper.querySelector('button[data-view="' + newView + '"]').classList.add('selected');

        } else {
            newView = el.dataset.view;

            if (el.classList.contains('selected')) {
                return false;
            }
            this.CalendarWrapper.dataset.selectedView = newView;
            el.closest('div.selectors').querySelectorAll('button.select-view').forEach(b => b.classList.contains('selected') && b.classList.remove('selected'));
            el.classList.add('selected');
        }

        this.selectedView = newView;
        this.CalendarWrapper.dataset.selectedView = this.selectedView;
        this.CalendarScreenEl.innerHTML = this.calendarCardRenderer();
        this.renderEvents();
    }

    connectGlobalEvents() {

        this.FiltersEl.querySelector('#sel-year').addEventListener('change', e => this.setNewDate({year: e.target.value}));
        this.FiltersEl.querySelector('#sel-month').addEventListener('change', e => this.setNewDate({month: e.target.value}));
        this.FiltersEl.querySelectorAll('button.select-view').forEach(but => but.addEventListener('click', e => this.changeView(e.currentTarget)));
        this.ModifierEl.querySelectorAll('.modifier button').forEach(button => button.addEventListener('click', e => {
            this.setNewDate((e.currentTarget.dataset.dir === 'prev' ? '-' + this.selectedView : '+' + this.selectedView));
        }));
    }

    async fetchData() {
        const response = await fetch(this.apiUrl + 'events' + '?_embed&order=asc&per_page=100&', {});
        return response.json();
    }

    showModal(eid) {
        const filteredEvent = Object.entries(this.eventsRowList).filter(x => x[1].id === parseInt(eid));

        if (!filteredEvent || !filteredEvent[0][1]) {
            return false;
        }

        const item = filteredEvent[0][1];

        document.querySelector('#eventModalDetails .content').innerHTML = Mustache.render('<article><strong class="title">{{{title}}}</strong><img src="{{img_url}}" alt="{{clear_title}}"/><div class="description"><span><label><span>Date:</span> {{date}}</label></span><span><label><span>Location:</span> {{location}}</label></span></div><div class="is-style-but-link"><a class="wp-block-button__link wp-element-button" href="{{link}}">{{link_caption}}</a></div></article>', {
            link_caption: 'Register',
            link: item.link,
            img_url: item.fimg_url ?? '',
            location: item.acf.location,
            date: item.acf.date_start + (item.acf.date_end && item.acf.date_end.length && item.acf.date_end !== item.acf.date_start ? ' - ' + item.acf.date_end : ''),
            title: item.title,
            clear_title: striptags(item.title)
        });

        document.querySelector('#eventModalDetails').classList.add('show');


    }

    getSelectedDate(format = 'YYYY-MM-DD') {

        if (format === 'noformat') {
            return moment([this.selectedDate.year, this.selectedDate.month, this.selectedDate.day], 'YYYY-MM-DD');
        } else {
            switch (format) {
                case 'MM-moment':
                    return this.selectedDate.month - 1;
                case 'DD':
                case 'MM':
                case 'YYYY':
                    return parseInt(moment([this.selectedDate.year, this.selectedDate.month, this.selectedDate.day], 'YYYY-MM-DD').format(format));
                default:
                    return moment([this.selectedDate.year, this.selectedDate.month, this.selectedDate.day], 'YYYY-MM-DD').format(format);
            }
        }
    }

    setNewDate(newDateObj) {
        let changed = false;

        if (typeof newDateObj === 'string') {
            let newDate;
            switch (newDateObj.substring(0, 1)) {
                case '+':
                    newDate = this.getSelectedDate('noformat').add(1, newDateObj.substring(1, newDateObj.length));
                    break;
                case '-':
                    newDate = this.getSelectedDate('noformat').subtract(1, newDateObj.substring(1, newDateObj.length));
                    break;
            }

            newDateObj = {
                year: parseInt(newDate.format('YYYY')),
                month: parseInt(newDate.format('MM')),
                day: parseInt(newDate.format('DD'))
            };
        }

        if (newDateObj.year < moment().year() - 1 || newDateObj.year > moment().year() + 1) {
            throw new Error('Niepoprawny zakres dat');
        }

        if (newDateObj.year) {
            this.selectedDate.year = parseInt(newDateObj.year);

            if (this.FiltersEl && this.FiltersEl.querySelector('#sel-year').value !== this.selectedDate.year) {
                this.FiltersEl.querySelector('#sel-year').value = this.selectedDate.year;
            }

            changed = true;
        }
        if (newDateObj.month) {
            this.selectedDate.month = parseInt(newDateObj.month);

            if (this.FiltersEl && this.FiltersEl.querySelector('#sel-month').value !== this.selectedDate.month) {
                this.FiltersEl.querySelector('#sel-month').value = this.selectedDate.month;
            }

            changed = true;
        }
        if (newDateObj.day) {
            this.selectedDate.day = parseInt(newDateObj.day);
            changed = true;
        }

        if (this.CalendarWrapper && this.CalendarWrapper.querySelector('span.current-date-caption')) {
            this.CalendarWrapper.querySelector('span.current-date-caption').innerHTML = '<span class="m">' + this.getSelectedDate('MMMM') + '</span><span class="y">' + this.getSelectedDate('YYYY') + '</span>';
        }
        if (changed && this.CalendarScreenEl) {
            // wszystko po zmianie daty....
            this.CalendarScreenEl.innerHTML = this.calendarCardRenderer();
            this.renderEvents();
        }

    }

    screenRenderer() {

        return Mustache.render('<div class="categories"></div><div class="selectors-wrapper"><div><div class="modifier"><button data-dir="prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">\n' + '<path d="M15.5 18.7598L9.5 12.7598L15.5 6.75977" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' + '</svg></button><button data-dir="next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">\n' + '<path d="M9.5 18.7598L15.5 12.7598L9.5 6.75977" stroke="#636363" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' + '</svg></button><span class="current-date-caption"><span class="m">{{curr_date_m}}</span><span class="y">{{curr_date_y}}</span></span></div><div class="selectors"><select id="sel-year">{{{dropdown_years}}}</select><select id="sel-month">{{{dropdown_months}}}</select><button data-view="month" class="select-view but-month selected">Month</button><button data-view="year" class="select-view but-year">Year</button></div></div></div><div class="calendar__headers">{{{days_header}}}</div><div class="calendar"></div><p class="empty-notice"></p>', {
            dropdown_years: this.makeDropdownYear(),
            dropdown_months: this.makeDropdownMonth(),
            days_header: this.getDaysName().join(''),
            curr_date_m: this.getSelectedDate('MMMM'),
            curr_date_y: this.getSelectedDate('YYYY'),
        });

    }

    updateEmptyNotice() {
        this.CalendarWrapper.querySelector('p.empty-notice').innerText = this.emptyNoticeText;
    }

    renderCalendarMonthCard(month) {

        let classesList = [];

        return Mustache.render('<div data-d-month="{{month}}" data-d-year="{{year}}" class="one-el {{classes}}"><span class="no">{{month_number}}</span><ul class="post-wrapper"></ul></div>', {
            month_number: month.format('MMM'),
            classes: classesList.join(' '),
            month: month.month() + 1,
            year: month.year(),
        });
    }

    renderCalendarDayCard(day) {
        if (typeof day === 'string') {
            day = moment(day);
        }

        let classesList = [];


        if (day.isBefore(moment())) {
            classesList.push('past');
        }
        if (day.isAfter(moment())) {
            classesList.push('future');
        }

        if (day.date() === moment().date() && day.month() === moment().month()) {
            classesList.push('current');
            classesList.indexOf('past') > -1 && classesList.splice(classesList.indexOf('past'), 1);
        }

        if (parseInt(day.format('MM')) < this.selectedDate.month) {
            classesList.push('prev-month');
        }
        if (parseInt(day.format('MM')) > this.selectedDate.month) {
            classesList.push('next-month');
        }

        return Mustache.render('<div data-day-no="{{day_no}}" data-d-day="{{day}}" data-d-month="{{month}}" data-d-year="{{year}}" class="one-el {{classes}}"><span class="no"><span>{{month_number}}</span>{{day_number}}</span><ul class="post-wrapper"></ul></div>', {
            month_number: day.format('MMM'),
            day_number: day.date(),
            classes: classesList.join(' '),
            day: day.date(),
            month: day.month() + 1,
            year: day.year(),
            day_no: day.day()
        });
    }

    calendarCardRenderer() {
        switch (this.selectedView) {
            case 'year':
                return this.calendarCardRenderer_year();
            case 'month':
            default:
                return this.calendarCardRenderer_month();
        }
    }

    calendarCardRenderer_year() {
        const currYear = this.getSelectedDate('YYYY');
        let calendarHtml = '';
        for (let i = 1; i <= 12; i++) {
            calendarHtml += this.renderCalendarMonthCard(moment([this.getSelectedDate('YYYY'), i], 'YYYY-MM'));
        }

        return calendarHtml;
    }

    calendarCardRenderer_month() {
        const daysInMonth = moment([this.getSelectedDate('YYYY'), this.getSelectedDate('MM-moment')]).daysInMonth();
        let firstDayNoInWeek = moment([this.getSelectedDate('YYYY'), this.getSelectedDate('MM-moment'), 1]).day();
        const lastDayNoInWeek = moment([this.getSelectedDate('YYYY'), parseInt(this.getSelectedDate('MM-moment')) + 1, 1]).subtract(1, 'day').day();
        const lastDayNo = moment([this.getSelectedDate('YYYY'), parseInt(this.getSelectedDate('MM-moment')) + 1, 1]).subtract(1, 'day').date();
        // console.log('master date:', this.getSelectedDate());
        // console.log('daysInMonth:', daysInMonth, this.getSelectedDate('MM'), moment([this.getSelectedDate('YYYY'), this.getSelectedDate('MM'), 'YYYY-MM-DD'], 'YYYY-MM'));
        // console.log('firstDayNoInWeek:', firstDayNoInWeek);

        let calendarHtml = '';

        if (firstDayNoInWeek === 0) {
            firstDayNoInWeek = 7;
        }


        if (firstDayNoInWeek > 1) {
            for (let i = firstDayNoInWeek - 1; i > 0; i--) {
                calendarHtml += this.renderCalendarDayCard(moment([this.getSelectedDate('YYYY'), this.getSelectedDate('MM'), 1], 'YYYY-MM-DD').subtract(i, 'day'));
            }
        }

        for (let i = 1; i <= daysInMonth; i++) {
            calendarHtml += this.renderCalendarDayCard(moment([this.getSelectedDate('YYYY'), this.getSelectedDate('MM'), i], 'YYYY-MM-DD'));
        }

        if (lastDayNoInWeek > 0) {
            let ii = 1;
            for (let i = lastDayNoInWeek; i < 7; i++) {
                calendarHtml += this.renderCalendarDayCard(moment([this.getSelectedDate('YYYY'), this.getSelectedDate('MM'), lastDayNo], 'YYYY-MM-DD').add(ii++, 'day'));
            }
        }


        return calendarHtml;
    }

    makeDropdownYear() {
        let html = '';

        for (let i = this.getSelectedDate('YYYY') - 1; i <= this.getSelectedDate('YYYY') + 1; i++) {
            html += Mustache.render('<option {{{selected_attrib}}} value="{{year}}">{{year}}</option>', {
                year: i, selected_attrib: this.currentDate.year === i ? 'selected="selected"' : ''
            });
        }

        return html;
    }

    makeDropdownMonth() {
        let html = '';
        for (let i = 1; i <= 12; i++) {

            html += Mustache.render('<option {{{selected_attrib}}} value="{{month_id}}">{{month}}</option>', {
                month_id: i,
                month: moment(i, 'MM').format('MMMM'),
                selected_attrib: this.currentDate.month === i ? 'selected="selected"' : ''
            });
        }

        return html;
    }

    getDaysName() {
        return [1, 2, 3, 4, 5, 6, 0].map((x) => '<span>' + moment().day(x).format('ddd') + '</span>');
    }
}
